export const generateCloudflareImage = (image: string | undefined | null) =>
  `https://imagedelivery.net/xVK12LCEYfLcBVg3-f6Ibg/${image}/cart`;
